import { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { httpClient } from '@/libs/api/HttpClient';

export enum Status {
  FORM,
  SENDING,
  SUCCESS,
}
type OptOutViewModel = {
  handleSubmit: (email: string) => Promise<void>;
  onCaptchaVerifiedChange: (value: string | null) => void;
  captchaValue: string | null;
  currentStatus: Status;
};
export const useOptOutViewModel = (): OptOutViewModel => {
  const params = useSearchParams();
  const success = !!params.get('success');
  const [currentStatus, setCurrentStatus] = useState<Status>(Status.FORM);
  const [captchaValue, setCaptchaValue] = useState<string | null>(null);
  const onCaptchaVerifiedChange = (value: string | null): void => {
    setCaptchaValue(value);
  };

  useEffect(() => {
    if (success) setCurrentStatus(Status.SUCCESS);
  }, [success]);

  const handleSubmit = async (email: string): Promise<void> => {
    try {
      const isSuccess = await httpClient.post('/account/opt-out', {
        email,
        token: captchaValue,
      });
      if (isSuccess) setCurrentStatus(Status.SENDING);
    } catch (error) {
      console.error(error);
    }
  };

  return {
    captchaValue,
    currentStatus,
    handleSubmit,
    onCaptchaVerifiedChange,
  };
};
